import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_6: FaireProductEntity = {
  token: "viverano-6",
  type: "product",
  name: "Women's Organic Cotton Bathrobe & Spa Robe",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/328514a886a78b1d299baeca691c11c7a5bd4540d1acdde926c34715571318ba.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 45,
  msrpDollars: 78,
  freeShipping: true,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_apparel-women"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
